import { Picture as PictureType } from '@tv2/lib-offspring/libs/image/picture';
import { memo } from 'react';

export const Picture = memo(
  ({ picture, className, alt }: { picture: PictureType; className?: string; alt?: string }) => {
    return (
      <picture>
        {picture.sources.map(s => (
          <source
            key={s.maxPixelWidth}
            media={s.maxPixelWidth ? `(max-width: ${s.maxPixelWidth}px)` : undefined}
            srcSet={s.sourceSet.map(z => `${z.url} ${z.dpr}x`).join(', ')}
          />
        ))}
        <img
          className={className}
          style={{ marginRight: 0 }}
          src={picture.url}
          alt={alt ?? ''}
          loading="lazy"
        />
      </picture>
    );
  }
);
